module.exports = __webpack_public_path__ + "static/media/flyerM42.e1ff2412.webp";